import moment from "moment";
import { createDataPointProcessor } from "../utils/dataPointProcessor";
import { applyLineGraphState } from "../utils/lineGraphState";
import {
  initializeDictionaries,
  initializeEmotionDict,
  initializeActionDictionaries,
} from "../utils/dictionaries";
import { updateEmotions } from "./emotionHandler";
import {
  transform,
  transformActions,
  transformFilteredData,
  transformAllActions,
  transformStudentSupportData,
  computeParticipationPercentChange,
} from "../utils/transformers";
import { processSpecificSchool } from "../utils/processSchools";
import { processSpecificClass } from "../utils/processClasses";

export function handleClass(state, className) {
  const { currentDict, compareDict } = initializeDictionaries();
  const { currentActionDict, compareActionDict } =
    initializeActionDictionaries();
  const currentParticipants = new Set();
  const compareParticipants = new Set();
  const emotionDict = initializeEmotionDict();
  let impactfulActions = { action: {}, emotion: {} };
  let newState = {};
  let filterDataPoints = [];
  let studentEmotionData = {};
  let studentSupportData = {};
  const bigFiveFilteredData = [];
  const lineGraphSourceData = [];
  // replace contextbig5 with equivalent not big5
  const contextFilteredDataPoints = [];
  let tooltipCounts = initializeEmotionDict();
  const now = moment();
  const currentDate = moment().subtract(state.filterAmountCurrent);
  const compareDate = moment().subtract(
    state.filterAmountCurrent + state.filterAmountCompare
  );

  const allEmotions = state.multiEmotion?.emotions || [];

  const processDataPoint = createDataPointProcessor(
    currentDate,
    compareDate,
    now,
    state.chosenEmotion,
    currentDict,
    compareDict,
    currentActionDict,
    compareActionDict,
    impactfulActions,
    filterDataPoints,
    studentEmotionData,
    studentSupportData,
    bigFiveFilteredData,
    state.selectedTimes,
    state.selectedSubOptions,
    state.helpfulFilter,
    tooltipCounts,
    currentParticipants,
    compareParticipants,
    allEmotions,
    lineGraphSourceData
  );

  if (className === "All Classes") {
    processSpecificSchool(state, state.chosenSchool, processDataPoint);
  } else {
    processSpecificClass(state, className, processDataPoint);
  }

  newState.chosenClass = className;
  newState.chosenStudent = "All Students";
  newState.filteredDataPoints = filterDataPoints;
  newState.bigFiveFilteredData = bigFiveFilteredData.sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );
  applyLineGraphState(newState, lineGraphSourceData, state.chosenTime, now);
  newState.contextFilteredDataPoints = contextFilteredDataPoints;
  newState.tooltipCounts = tooltipCounts;
  updateEmotions(
    state.feeling,
    state.filterAmountCurrent,
    state.chosenDistrict,
    state,
    emotionDict,
    newState
  );

  transform(currentDict, compareDict, newState);
  transformAllActions(currentActionDict, compareActionDict, newState);
  transformActions(impactfulActions, newState);
  transformFilteredData(studentEmotionData, state.chosenPercentage, newState);
  transformStudentSupportData(
    studentSupportData,
    state.chosenPercentage,
    newState
  );

  computeParticipationPercentChange(
    currentParticipants,
    compareParticipants,
    newState
  );
  return newState;
}
